import React, { useEffect, useState } from "react";
import {
  transformResultsToCompProfileData,
  formatBoldText,
  checkColumns,
} from "../../../../../services/commonService";
import InsightTable from "../../InsightTable";
import ParsedTextWithLinks from "../../../../HtmlElements/ParsedTextWithLinks";

function MarketPositionByApplication({ marketByApplication, compView }) {
  const [tabData, setTabData] = useState([]);
  const [tableBelowDescription, setTableBelowDescription] = useState("");
  const [chartData, setChartData] = useState({});
  const [columns, setColumns] = useState([]);
  const [sidebarColumns, setSidebarColumns] = useState([]);
  const [hiddenColumns, setHiddenColumns] = useState([
    "key_customer_segments",
    "key_products",
    "strategic_significance",
  ]);

  let allMetrics = [];

  useEffect(() => {
    if (compView === "quantitative") {
      allMetrics = [
        // { key: "application_segment", label: "Segment Name" },
        {
          key: "application_market_size",
          label: "Market Size",
          width: "120px",
        },
        { key: "application_cagr", label: "CAGR", width: "100px" },
        // {
        //   key: "company_market_share",
        //   label: "Revenue Contribution (%)",
        //   width: "205px",
        // },
        {
          key: "company_market_revenue_percentage",
          label: "Revenue Contribution (%)",
          width: "205px",
        },
      ];
      setHiddenColumns([]);
      setSidebarColumns([]);
      setColumns(allMetrics);
    } else {
      allMetrics = [
        // { key: "application_segment", label: "Segment Name" },
        {
          key: "application_market_size",
          label: "Market Size",
          width: "120px",
        },
        { key: "application_cagr", label: "CAGR", width: "100px" },
        // {
        //   key: "company_market_share",
        //   label: "Revenue Contribution (%)",
        //   width: "205px",
        // },
        {
          key: "company_market_revenue_percentage",
          label: "Revenue Contribution (%)",
          width: "210px",
        },
        // {
        //   key: "company_market_size",
        //   label: "Company Market Size",
        //   width: "160px",
        // },
        { key: "company_position", label: "Company Focus", width: "145px" },
        { key: "key_customer_segments", label: "Key Customer Segments" },
        { key: "key_products", label: "Key Products" },
        { key: "strategic_significance", label: "Strategic Significance" },
      ];
      setHiddenColumns([
        "key_customer_segments",
        "key_products",
        "strategic_significance",
      ]);
      setSidebarColumns([
        "key_customer_segments",
        "key_products",
        "strategic_significance",
      ]);
      setColumns(allMetrics);
    }
  }, [compView]);

  const dummyData = [
    {
      primary_market: {
        value: "Adhesives & Sealants Market",
        // source: "https://placeholder.source.com",
        // data_type: "Qualitative",
        // confidence_score: 0.75,
        // reasoning:
        //   "Generated from internal analysis and stakeholder interviews.",
      },
      global_market_size: {
        value: "$63.4B globally",
        // source: "https://placeholder.source.com",
        // data_type: "Qualitative",
        // confidence_score: 0.75,
        // reasoning:
        //   "Generated from internal analysis and stakeholder interviews.",
      },
      taylor_position: {
        value: "Small Player",
        // source: "https://placeholder.source.com",
        // data_type: "Qualitative",
        // confidence_score: 0.75,
        // reasoning:
        //   "Generated from internal analysis and stakeholder interviews.",
      },
      competitive_ranking: {
        value: "Top 50+ player",
      },
      strategic_significance: {
        value: "Global industry context",
      },
    },
    // Second entry (Post-Acute Care) → similar structure
  ];

  useEffect(() => {
    // setTabData(dummyData);
    const transformed = transformResultsToCompProfileData(marketByApplication);

    // Check if columns meet multiple conditions
    const columnConditions = {
      company_market_share: ["lessThan1"],
      // technology_cagr: ["lessThan1"],
    };

    if (checkColumns(Object.values(transformed), columnConditions)) {
      setHiddenColumns((prev) => [...prev, ...Object.keys(columnConditions)]);
    }

    setTabData(transformed);
    setTableBelowDescription(
      // formatBoldText(
      //   marketByApplication?.[0]?.response?.["tableComments"]
      // )
      <ParsedTextWithLinks
        text={marketByApplication?.[0]?.response?.["tableComments"] || ""}
      />
    );

    let tempChartData = { data_set: [] };
    transformed.forEach((applicationData) => {
      tempChartData.data_set.push({
        application_segment: applicationData.application_segment?.value || "",
        application_market_size: parseFloat(
          (applicationData.application_market_size?.value !== "Undisclosed"
            ? applicationData.application_market_size?.value || "0"
            : "0"
          ).replace(/[^0-9.]/g, "")
        ),
        application_cagr: parseFloat(
          (applicationData.application_cagr?.value !== "Undisclosed"
            ? applicationData.application_cagr?.value || "0"
            : "0"
          ).replace(/[^0-9.]/g, "")
        ),
      });
    });

    if (tempChartData.data_set.length > 0) {
      setChartData(tempChartData);
      // console.log("TECH CHART DATA: ", tempChartData);
    }
  }, [marketByApplication]);

  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    // { type: "conversation", title: "Conversation", onClick: () => {} },
    // { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  return (
    <InsightTable
      // title="By Application – North America"
      title="By Application"
      subtitle=""
      // belowTableDescription="The shocking reality: Taylor's estimated $300M [1][3] revenue represents just 0.47% of the $63.4B [2] global market, yet they've built a sustainable business by owning specific premium segments completely. This reveals their true competitive advantage isn't scale - it's specialization depth that larger players like H.B. Fuller struggle to replicate without cannibalizing their own volume-based strategies."
      belowTableDescription={tableBelowDescription}
      data={tabData}
      metrics={columns}
      rowIdentifier={["application_segment"]}
      actions={actions}
      // extraIdentifierColumns={[
      //   { key: "application_market_size", label: "Size" },
      //   { key: "application_cagr", label: "CAGR" },
      // ]}
      // hiddenColumns={["application_market_size", "application_cagr"]}
      hiddenColumns={hiddenColumns}
      sidecardColumns={sidebarColumns}
      chartId="market_position_by_application_bubble_chart"
      chartData={chartData}
      chartType="bubble_chart"
      xField="application_market_size"
      yField="application_cagr"
      nameField="application_segment"
      sizeField="application_market_size"
      colorField="bubble_color"
      xAxisLabel="Application Size (Bn)"
      yAxisLabel="CAGR (%)"
    />
  );
}

export default MarketPositionByApplication;
